import styled from "styled-components";

export const UlColumnList = styled.ul`
  list-style: none;
  margin: 1.75rem 0;
  padding-left: 1rem;
`;

export const LiColumnList = styled.li`
  background: white;
  border-radius: 0 0.5rem 0.5rem 0.5rem;
  box-shadow: 0.25rem 0.25rem 0.6rem rgba(0, 0, 0, 0.05),
    0 0.5rem 1.125rem rgba(75, 0, 0, 0.05);
  margin-top: 1rem;
  min-height: 3rem;
  padding: 1rem 1rem 1rem 7.5rem;
  position: relative;
  display: flex;
  section {
    width: 80px;
    /* justify-content: flex-start; */
    margin-left: auto;
    display: flex;
    justify-content: space-between;
  }
  li:first-child {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 10px;
  }
  p {
    max-width: 800px;
  }

  ul {
    list-style: none;
    width: 100%;
  }

  div form button {
    margin-top: 0;
  }
`;

export const TitleColumnList = styled.h4`
  font-size: 1rem;
  background: linear-gradient(135deg, #fff 0%, #81c6d3 50%, #1e5862 100%);
  font-weight: bold;
  border-radius: 1rem 1rem 0 1rem;
  height: 3rem;
  left: -1rem;
  overflow: hidden;
  position: absolute;
  top: -1rem;
  width: auto;
  align-items: flex-start;
  box-shadow: 0.25rem 0.25rem 0.6rem rgba(0, 0, 0, 0.05),
    0 0.5rem 1.125rem rgba(75, 0, 0, 0.05);
  color: #032156;
  display: flex;
  justify-content: flex-end;
  padding: 1rem;
  /* ${(props) => (!props.isShowModal ? "z-index: 1;" : "")} */
`;
